import { render, staticRenderFns } from "./Battery.vue?vue&type=template&id=2f5f13b5&scoped=true"
import script from "./Battery.vue?vue&type=script&lang=js"
export * from "./Battery.vue?vue&type=script&lang=js"
import style0 from "./Battery.vue?vue&type=style&index=0&id=2f5f13b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f13b5",
  null
  
)

export default component.exports